(function () {
  var el = document.querySelector('[data-okpu]');
  if (!el || el.__okpu) return;
  el.__okpu = true;

  /* ── Versión única: v6 (19/10) ──────────────────────────────────────
     La prueba A/B v5.1 frente a v6 (29/09–19/10) se cerró el 19/10: se queda la v6 para todos (decisión del
     dueño). La clase okpu--v6 ya viene en el HTML del snippet. El atributo de carrito pasa a
     okp_upsell_shown = 'v6.1|…' (v6 sin titular general y con el gancho dentro de la tarjeta del Misterioso), así los
     pedidos nuevos no se mezclan con los de la prueba (v5.1| / v6|) y el panel los ignora. Historia y lectura: docs/okp-upsell-ab.md
     y docs/okp-pruebas-ab.md. Se limpia lo que la prueba dejó en el navegador. */
  try { localStorage.removeItem('okpu_ab'); localStorage.removeItem('okpv_popup_v6'); localStorage.removeItem('okpv_popup_v5.1'); } catch (e) {}
  /* okpVista / okpForzada: los usa la prueba del carrito (okp-cart-upsell.js), que sigue en marcha.
     Se definen en el primero de los dos scripts que cargue. */
  if (!window.okpVista) {
    /* ?okpu= ya no cambia nada en el popup, pero sigue marcando el navegador como «forzado» (costumbre del equipo). */
    try { if (/[?&](okpu|okpd)=/.test(location.search)) localStorage.setItem('okp_ab_forzada', '1'); } catch (e) {}
    window.okpForzada = function () { try { return localStorage.getItem('okp_ab_forzada') === '1'; } catch (e) { return false; } };
    window.okpVista = function (prueba, version) {
      try { var k = 'okpv_' + prueba + '_' + version; if (localStorage.getItem(k)) return; localStorage.setItem(k, '1'); } catch (e) { return; }
      fetch('https://qzemrdjzvspnfqljfjvo.supabase.co/rest/v1/rpc/okp_ab_ver', { method: 'POST', keepalive: true,
        headers: { apikey: 'sb_publishable_GuU0l8p7nwXIWrlw62FJVg_bm8gChpG', 'Content-Type': 'application/json' },
        body: JSON.stringify({ p_prueba: prueba, p_version: version, p_forzada: window.okpForzada() }) }).catch(function () {});
    };
  }
  var VER = 'v6.1';
  /* Familia del Misterioso según el perfume añadido (casi nadie deja Unisex). */
  var fam = el.dataset.fam;
  if (fam) {
    var fb = el.querySelector('[data-okpu-v][data-t="' + fam + '"]');
    /* Se aplica directamente, SIN simular un clic: un .click() sintético llega a los
       escuchadores de clic de todo el documento (tema y apps) y alguno falla con él. */
    if (fb && !fb.classList.contains('on')) setTimeout(function () { eligeFamilia(fb); }, 0);
  }
  /* Cabecera de v6: «GGL · 100 mL · 23,95 €» del último artículo añadido. */
  function lineaAnadido(c) {
    var n = el.querySelector('[data-okpu-linea]'), it = c && c.items && c.items[0];
    if (!n || !it) return;
    var m = String(it.product_title || '').match(/^([A-Z0-9]{2,5})\s+[-–—]\s+/);
    var partes = [];
    if (m) partes.push(m[1]);
    if (it.variant_title && !/default/i.test(it.variant_title)) partes.push(it.variant_title);
    partes.push(dinero(it.final_price));
    n.textContent = partes.join(' · ');
  }
  var MAX = parseInt(el.dataset.maxSession, 10) || 2;
  var KEY = 'okpu_views', FLAG = 'okpu_offered';
  var abierto = false, yaMostrado = false, resuelto = false, antes = null;
  var MONEDA = null;

  var lista = el.querySelector('[data-okpu-list]');
  var handles = [].map.call(el.querySelectorAll('[data-okpu-item]'), function (n) {
    return n.dataset.handle;
  });

  function vistas() { try { return parseInt(sessionStorage.getItem(KEY), 10) || 0; } catch (e) { return 0; } }
  function suma()   { try { sessionStorage.setItem(KEY, vistas() + 1); } catch (e) {} }

  /* Marca para que okp-cart-upsell no repita lo que se acaba de enseñar.
     Se guardan IDs de VARIANTE porque es lo que filtra allí (`candidates`).
     El Misterioso queda fuera a propósito: en el drawer funciona bien. */
  function marcar() {
    try {
      var vids = [];
      [].forEach.call(el.querySelectorAll('[data-okpu-item]'), function (n) {
        if (n.dataset.kind === 'mystery') return;
        if (n.dataset.vid) vids.push(n.dataset.vid);
      });
      sessionStorage.setItem(FLAG, vids.join(','));
    } catch (e) {}
  }

  function track(n, p) {
    try {
      window.dataLayer = window.dataLayer || [];
      var d = { event: n }; for (var k in p) d[k] = p[k];
      window.dataLayer.push(d);
    } catch (e) {}
  }
  function vivas() { return el.querySelectorAll('[data-okpu-item]:not([hidden])').length; }

  function dinero(cent) {
    return (cent / 100).toLocaleString(document.documentElement.lang || 'es-ES',
      { style: 'currency', currency: MONEDA || 'EUR' });
  }

  /* Medición del denominador: "a este carrito se le enseñó el popup".
     ATRIBUTO DE CARRITO, no propiedad de línea. La v5 marcaba la línea del padre
     con properties[_okp_upsell_shown] y eso PARTÍA EL CARRITO: Shopify solo funde
     dos líneas si coinciden variante Y propiedades, así que en cuanto el mismo
     artículo entraba por otra vía que no estampa la propiedad (barra sticky,
     quick-add, la página /cart, o una segunda visita con el tope de sesión ya
     agotado) aparecía una segunda línea del mismo SKU en vez de cantidad 2.
     Al cliente le parecía que algo se añadía solo.
     El atributo vive a nivel de carrito, llega al pedido como note_attribute y no
     puede partir ninguna línea. Además es semánticamente lo correcto: que se
     enseñara el popup es un hecho de la sesión, no de un artículo. */
  var marcado = false;
  function marcarCarrito() {
    if (marcado) return;
    marcado = true;
    var attrs = {};
    attrs['okp_upsell_shown'] = VER + '|' + handles.join(',');
    if (window.okpForzada && window.okpForzada()) attrs['okp_ab_forzada'] = '1';
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () { marcado = false; });
  }

  /* Puntos: uno por tarjeta viva, sincronizados con el scroll del carrusel. */
  var dots = el.querySelector('[data-okpu-dots]');
  function pintaDots() {
    if (!dots || !lista) return;
    var items = el.querySelectorAll('[data-okpu-item]:not([hidden])');
    dots.innerHTML = '';
    if (items.length < 2) return;
    for (var i = 0; i < items.length; i++) {
      var s = document.createElement('span');
      if (i === 0) s.className = 'on';
      dots.appendChild(s);
    }
  }
  /* Con rectángulos, no con offsetLeft: las tarjetas son `position:relative`
     dentro de una hoja también posicionada, así que su offsetLeft NO está en el
     mismo sistema que el scrollLeft del carrusel y el punto activo se quedaba
     clavado en la primera. */
  function syncDots() {
    if (!dots || !lista || !dots.children.length) return;
    var items = el.querySelectorAll('[data-okpu-item]:not([hidden])');
    var rl = lista.getBoundingClientRect();
    var centro = rl.left + rl.width / 2;
    var act = 0, min = Infinity;
    for (var i = 0; i < items.length; i++) {
      var r = items[i].getBoundingClientRect();
      var d = Math.abs(r.left + r.width / 2 - centro);
      if (d < min) { min = d; act = i; }
    }
    for (var j = 0; j < dots.children.length; j++) {
      dots.children[j].className = (j === act) ? 'on' : '';
    }
  }
  /* Flechas de escritorio: con el dedo se arrastra el carrusel, con ratón no.
     Avanzan una tarjeta y se apagan al llegar a cada extremo. */
  var navs = el.querySelectorAll('[data-okpu-nav]');
  function paso() {
    var it = el.querySelector('[data-okpu-item]:not([hidden])');
    return it ? it.getBoundingClientRect().width + 12 : 260;
  }
  function syncNav() {
    if (!lista || navs.length < 2) return;
    var tope = lista.scrollWidth - lista.clientWidth;
    var hay = tope > 4;
    navs[0].disabled = !hay || lista.scrollLeft <= 2;
    navs[1].disabled = !hay || lista.scrollLeft >= tope - 2;
  }
  if (lista) lista.addEventListener('scroll', function () { syncDots(); syncNav(); }, { passive: true });

  /* ── Motor de recomendaciones ──────────────────────────────────────────
     Las demás tarjetas salen de un mapa fijo de seis productos. Esta sale del
     motor nativo de Shopify sobre TODO el catálogo, enriquecido por
     sections/okp-reco-json.liquid: descarta género incompatible (nunca
     femenino↔masculino), cuenta familias olfativas compartidas y localiza la
     variante de 30 mL con su propia foto.

     No puede ir pre-renderizada, y no solo por ser una llamada de red: esa
     sección deriva el perfume fuente DEL CARRITO, así que si se pide al abrir
     el popup el artículo aún no ha entrado y compararía contra el carrito
     anterior. Por eso cuelga de `ajaxProduct:added`, que es cuando el tema
     confirma el añadido. Llega en ~200-400 ms y entra al final del carrusel:
     el tiempo de apertura no se toca.

     m >= 1 familia compartida -> "Huele como el tuyo" (el claim se sostiene).
     m == 0 -> se baja el claim a co-compra del motor, que es lo que hay. */
  var motorPedido = false;
  function pideMotor() {
    var tpl = el.querySelector('[data-okpu-tpl]');
    if (motorPedido || !tpl || !lista || !el.dataset.pid) return;
    motorPedido = true;

    fetch('/recommendations/products?section_id=okp-reco-json&product_id='
          + encodeURIComponent(el.dataset.pid) + '&limit=10&intent=related')
      .then(function (r) { if (!r.ok) throw new Error('http'); return r.text(); })
      .then(function (html) {
        var d = document.createElement('div');
        d.innerHTML = html;
        return JSON.parse((d.textContent || '').trim());
      })
      .then(function (recs) {
        if (!recs || !recs.length) return;
        return fetch('/cart.js').then(function (r) { return r.json(); })
          .then(function (c) { motorPinta(recs, c, tpl); });
      })
      .catch(function () {});   // sin recomendaciones el popup se queda como estaba
  }

  function motorPinta(recs, carrito, tpl) {
    /* Fuera lo que ya se está enseñando aquí (incluidas las tres variantes del
       Misterioso, que se intercambian con el selector) y lo que ya va en el carrito. */
    var fuera = [].map.call(el.querySelectorAll('[data-okpu-item]'), function (n) {
      return parseInt(n.dataset.vid, 10);
    });
    [].forEach.call(el.querySelectorAll('[data-okpu-v]'), function (n) {
      fuera.push(parseInt(n.dataset.okpuV, 10));
    });
    (carrito.items || []).forEach(function (i) { fuera.push(i.variant_id); });

    var pool = recs.filter(function (x) { return fuera.indexOf(x.vid) === -1; });
    if (!pool.length) return;

    var mejor = pool.reduce(function (a, b) { return (b.m || 0) > (a.m || 0) ? b : a; }, pool[0]);
    var esFamilia = (mejor.m || 0) >= 1;
    var pick = esFamilia ? mejor : pool[0];

    var n = tpl.content.firstElementChild.cloneNode(true);
    n.dataset.vid = pick.vid;
    n.querySelector('.okpu-eb').textContent  = esFamilia ? tpl.dataset.tFam : tpl.dataset.tMot;
    n.querySelector('.okpu-n').textContent   = pick.title;
    n.querySelector('.okpu-pr').textContent  = dinero(pick.p);
    n.querySelector('.okpu-why').textContent = esFamilia ? tpl.dataset.tFamWhy : tpl.dataset.tMotWhy;
    n.querySelector('.okpu-a-p').textContent = '· ' + dinero(pick.p);
    var img = n.querySelector('img');
    if (pick.img) img.src = pick.img; else img.parentNode.removeChild(img);

    lista.appendChild(n);
    track('okp_upsell_motor', { kind: esFamilia ? 'familia' : 'co-compra', m: mejor.m || 0 });
    pintaDots(); syncNav();
  }

  function abrir() {
    if (abierto || yaMostrado || vistas() >= MAX || !vivas()) return;
    abierto = true; yaMostrado = true; resuelto = false;
    el.hidden = false;
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    suma(); marcar(); pintaDots(); syncNav(); retenDrawer();
    /* 19/10: el foco entra en la hoja (teclado y lectores de pantalla); antes se quedaba en el botón de detrás. */
    antes = document.activeElement;
    var sh = el.querySelector('.okpu-sheet');
    if (sh) try { sh.focus({ preventScroll: true }); } catch (e) {}
    track('okp_upsell_shown', { source: 'okp-upsell-popup-atc', offers: vivas(), version: VER });

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        MONEDA = c.currency || MONEDA;
        var porHandle = {}, porVariante = {};
        (c.items || []).forEach(function (i) {
          porHandle[i.handle] = true; porVariante[i.variant_id] = true;
        });
        [].forEach.call(el.querySelectorAll('[data-okpu-item]'), function (n) {
          /* La tarjeta de formato viaje es del MISMO producto que se acaba de
             añadir, así que por handle se descartaría siempre. Esa se mira por
             variante: solo sobra si lo que se llevó ya ES el frasco de 30 ml. */
          var sobra = n.dataset.match === 'variant'
            ? porVariante[parseInt(n.dataset.vid, 10)]
            : porHandle[n.dataset.handle];
          if (sobra) n.hidden = true;
        });
        pintaDots(); syncNav();
        total(c);
        if (!vivas() && abierto) cerrar(true);
      })
      .catch(function () {});
  }

  /* ── Drawer y popup no conviven ────────────────────────────────────────
     El tema abre el drawer cuando el añadido del producto termina (~400 ms),
     o sea DESPUÉS de que el popup ya esté en pantalla: quedaban los dos
     modales encadenados. Mientras el popup esté abierto se mantiene cerrado, y
     al cerrarlo se abre, que es el remate natural del flujo.
     No basta con cerrarlo una vez al abrir: el tema lo abre más tarde, así que
     hace falta vigilar la clase que marca el drawer abierto.
     Se usa la API del propio tema (theme.CartDrawer escucha cart:open y
     cart:close, assets/theme.js:2158) para no romper transiciones ni foco. */
  var vigilante = null;
  function drawerAbierto() {
    return document.documentElement.classList.contains('js-drawer-open');
  }
  function retenDrawer() {
    if (drawerAbierto()) document.dispatchEvent(new CustomEvent('cart:close'));
    if (vigilante) return;
    vigilante = new MutationObserver(function () {
      if (abierto && drawerAbierto()) document.dispatchEvent(new CustomEvent('cart:close'));
    });
    vigilante.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }
  /* El cart:open va DIFERIDO a propósito. Se cierra el popup desde un clic, y ese
     mismo clic sigue burbujeando hasta el manejador de "clic fuera -> cerrar
     drawer" del tema: si abrimos el drawer de forma síncrona, ese manejador lo
     cierra en el acto y no pasa nada. Al saltar al siguiente turno del bucle de
     eventos, el clic ya se ha consumido. Los 90 ms además dan un respiro visual
     entre que desaparece la hoja y entra el drawer. */
  function sueltaDrawer() {
    if (vigilante) { vigilante.disconnect(); vigilante = null; }
    setTimeout(function () {
      if (!abierto && !drawerAbierto()) document.dispatchEvent(new CustomEvent('cart:open'));
    }, 90);
  }

  function cerrar(abreCesta) {
    if (!abierto) return;
    abierto = false;
    el.hidden = true;
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    track('okp_upsell_closed', { version: VER });
    /* 02/10 (decisión del usuario): en v6 cerrar con la X, el fondo o Esc tampoco abría la cesta, y casi
       nadie llegaba a ver las ofertas del carrito. Ahora cualquier cierre la abre, como en v5.1. */
    sueltaDrawer();
  }

  function total(c) {
    var b = el.querySelector('[data-okpu-total]');
    if (b && c && typeof c.total_price === 'number') b.textContent = '· ' + dinero(c.total_price);
  }

  /* El total del pie subiendo es la confirmación de verdad: es donde el cliente
     ve la consecuencia de lo que acaba de pulsar. Se marca con un pulso corto. */
  function pulsoTotal() {
    var g = el.querySelector('.okpu-go');
    if (!g || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    g.classList.remove('bump');
    void g.offsetWidth;
    g.classList.add('bump');
    g.addEventListener('animationend', function q() {
      g.classList.remove('bump'); g.removeEventListener('animationend', q);
    });
  }

  function confirmar() {
    if (resuelto) return;
    resuelto = true;
    var l = el.querySelector('[data-okpu-lbl]');
    var a = el.querySelector('[data-okpu-add]');
    if (l && a) l.textContent = a.dataset.done;
  }

  /* Solo abrimos. Ya no se toca el formulario del producto: la marca de medición
     es un atributo de carrito y la pone abrir(). */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('form[action="/cart/add"] [type="submit"], form[action="/cart/add"] button:not([type="button"])');
    if (!b || b.disabled) return;
    abrir();
  }, true);

  document.addEventListener('submit', function (e) {
    if (e.target && e.target.matches && e.target.matches('form[action="/cart/add"]')) abrir();
  }, true);

  /* El atributo del carrito se escribe AQUÍ, con el artículo ya dentro, y no en el
     clic: sin carrito previo, un /cart/update.js en paralelo con el /cart/add.js
     crea dos carritos distintos y el navegador se queda con uno de los dos. */
  document.addEventListener('ajaxProduct:added', function () {
    confirmar();
    if (!abierto) abrir();
    if (abierto) pideMotor();   // ahora el artículo ya está en el carrito
    if (yaMostrado) marcarCarrito();
    fetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (c) { total(c); lineaAnadido(c); }).catch(function () {});
  });

  /* 19/10: si el tema no puede añadir (sin stock, límite de cantidad), cierra el popup SIN abrir la cesta para que se
     vea el error que el tema pone en el formulario, y devuelve el foco. Podrá salir en el siguiente añadido bueno. */
  document.addEventListener('ajaxProduct:error', function () {
    if (!abierto || resuelto) return;
    abierto = false; yaMostrado = false;
    el.hidden = true;
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (vigilante) { vigilante.disconnect(); vigilante = null; }
    if (antes && antes.focus) try { antes.focus({ preventScroll: true }); } catch (e) {}
    track('okp_upsell_closed', { version: VER, motivo: 'error' });
  });

  function eligeFamilia(v) {
    var it = v.closest('[data-okpu-item]');
    if (!it) return;
    [].forEach.call(it.querySelectorAll('[data-okpu-v]'), function (n) {
      n.classList.remove('on'); n.setAttribute('aria-checked', 'false');
    });
    v.classList.add('on'); v.setAttribute('aria-checked', 'true');
    it.dataset.vid = v.dataset.okpuV;
    if (v.dataset.price) {
      var p = dinero(parseInt(v.dataset.price, 10) || 0);
      var now = it.querySelector('[data-okpu-now]');
      var bp  = it.querySelector('[data-okpu-btnp]');
      if (now) now.textContent = p;
      if (bp)  bp.textContent  = '· ' + p;
    }
  }

  el.addEventListener('click', function (e) {
    var cz = e.target.closest('[data-okpu-close]');
    if (cz) { cerrar(cz.classList.contains('okpu-no')); return; }

    var nv = e.target.closest('[data-okpu-nav]');
    if (nv) {
      lista.scrollBy({ left: parseInt(nv.dataset.okpuNav, 10) * paso(), behavior: 'smooth' });
      return;
    }

    /* Familia del Misterioso */
    var v = e.target.closest('[data-okpu-v]');
    if (v) { eligeFamilia(v); return; }

    var btn = e.target.closest('[data-okpu-add]');
    if (!btn || btn.disabled) return;
    var item = btn.closest('[data-okpu-item]');
    var vid  = item.dataset.vid;
    if (!vid) return;

    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(vid, 10), quantity: 1,
                  properties: { _okp_upsell: 'popup-atc' } }]
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function () {
        item.classList.add('done');
        btn.querySelector('.okpu-a-t').textContent = btn.dataset.doneb || btn.dataset.done;
        /* Se apunta QUÉ aceptó para que el drawer decida qué ofrecer después.
           Lo lee snippets/okp-cart-upsell.liquid: si aquí se llevó el Misterioso,
           allí no se le vuelven a ofrecer muestras (mismo mecanismo de compra a
           ciegas; dispararlo dos veces en diez segundos lo quema). */
        try {
          var tom = (sessionStorage.getItem('okpu_taken') || '').split(',').filter(Boolean);
          if (tom.indexOf(item.dataset.kind) === -1) tom.push(item.dataset.kind);
          sessionStorage.setItem('okpu_taken', tom.join(','));
        } catch (e) {}
        track('add_to_cart', { source: 'okp-upsell-popup-atc', quantity: 1 });
        document.dispatchEvent(new CustomEvent('cart:build'));
        return fetch('/cart.js').then(function (r) { return r.json(); })
          .then(function (c) { total(c); pulsoTotal(); });
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.querySelector('.okpu-a-t').textContent = btn.dataset.lbl;
        track('okp_upsell_error', { error: String(err && err.message || err) });
      });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && abierto) cerrar();
  });
})();
